// extracted by mini-css-extract-plugin
module.exports = {"textInput":"input_textInput__EVUoG","reset":"input_reset__Y9R5L","warning":"input_warning__RVri3"};